(function () {
  'use strict';
  function boot() {
    var dataNode = document.getElementById('outletlet-japan-locale');
    if (!dataNode || window.__outletletJapanLocale) return;
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }
    if (data.locale !== 'ja') return;
    window.__outletletJapanLocale = true;
    var normalize = function (value) { return String(value || '').replace(/\s+/g, ' ').trim(); };
    var textMap = new Map(data.pairs.map(function (pair) { return [normalize(pair[0]), pair[1]]; }));
    var pageRoot = document.querySelector('.__pf');
    var isMirror = /\/pages\/digital-rearview-mirror\/?$/.test(location.pathname);
    var isContact = /\/pages\/contact\/?$/.test(location.pathname);
    var skip = 'script,style,noscript,textarea,input,select,option,[contenteditable="true"],#looxReviews,.loox-review,[data-loox-review]';
    var policyTemplate = document.getElementById('outletlet-japan-policy-preview');
    var policyBody = document.querySelector('.shopify-policy__body');
    if (policyTemplate && policyBody) policyBody.replaceChildren(policyTemplate.content.cloneNode(true));
    function translateText(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        if (!node.parentElement || node.parentElement.closest(skip)) return;
        var value = normalize(node.nodeValue);
        if (/^Go to slide \d+$/.test(value)) node.nodeValue = 'スライド' + value.match(/\d+$/)[0] + 'を表示';
        if (isMirror && /^\d+% OFF$/.test(value)) node.nodeValue = value.replace('% OFF', '%割引');
        if (isContact) {
          var labels = {ADDRESS:'所在地', EMAIL:'メール', PHONE:'電話', 'FOLLOW US':'公式SNS'};
          Object.keys(labels).forEach(function (label) {
            if (value.toUpperCase() === label || value.toUpperCase().indexOf(label + ' ') === 0) node.nodeValue = node.nodeValue.replace(new RegExp(label, 'i'), labels[label]);
          });
        }
        if (textMap.has(value)) node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), textMap.get(value));
      });
      root.querySelectorAll('[aria-label],img[alt],[title],[placeholder]').forEach(function (el) {
        if (el.closest('script,style,noscript,#looxReviews,.loox-review,[data-loox-review]')) return;
        ['aria-label', 'alt', 'title', 'placeholder'].forEach(function (attr) {
          var value = el.getAttribute(attr);
          if (value && attr === 'aria-label' && value.endsWith('の数量') && textMap.has(normalize(value.slice(0, -3)))) el.setAttribute(attr, textMap.get(normalize(value.slice(0, -3))) + 'の数量');
          else if (value && textMap.has(normalize(value))) el.setAttribute(attr, textMap.get(normalize(value)));
          else if (value && /^Go to slide \d+$/.test(value)) el.setAttribute(attr, 'スライド' + value.match(/\d+$/)[0] + 'を表示');
          else if (value && /^View mirror product image \d+$/.test(value)) el.setAttribute(attr, '商品画像' + value.match(/\d+$/)[0] + 'を見る');
          else if (value && /^Product gallery control \d+$/.test(value)) el.setAttribute(attr, '商品画像の表示切り替え ' + value.match(/\d+$/)[0]);
          else if (value && /^OUTLETLET 4K Digital Rearview Mirror product view \d+$/.test(value)) el.setAttribute(attr, 'OUTLETLET デジタルルームミラー 商品画像' + value.match(/\d+$/)[0]);
        });
      });
    }
    function replaceImages() {
      if (!isMirror || !pageRoot) return;
      var paymentTemplate = document.getElementById('outletlet-japan-payment-methods');
      if (paymentTemplate) pageRoot.querySelectorAll('img[src*="dddd1-1682842570353"]').forEach(function (img) { img.replaceWith(paymentTemplate.content.cloneNode(true)); });
      pageRoot.querySelectorAll('img').forEach(function (img) {
        var src = img.getAttribute('src') || '';
        var asset = data.images.find(function (item) { return src.indexOf('/' + item.source) !== -1; });
        if (!asset) return;
        if (img.getAttribute('src') !== asset.url) img.src = asset.url;
        ['srcset', 'data-srcset', 'data-src', 'data-lazy-src', 'data-lazy-srcset'].forEach(function (attr) { img.removeAttribute(attr); });
        img.alt = asset.alt;
        var picture = img.closest('picture');
        if (picture) picture.querySelectorAll('source').forEach(function (source) { source.srcset = asset.url; });
      });
      pageRoot.querySelectorAll('[data-image],a[href]').forEach(function (el) {
        ['data-image', 'href'].forEach(function (attr) {
          var value = el.getAttribute(attr) || '';
          var asset = data.images.find(function (item) { return value.indexOf('/' + item.source) !== -1; });
          if (asset) el.setAttribute(attr, asset.url);
        });
      });
    }
    function localizeLinks() {
      document.querySelectorAll('a[href]').forEach(function (link) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) === '#' || /^(mailto:|tel:)/.test(href)) return;
        var url;
        try { url = new URL(href, location.origin); } catch (error) { return; }
        if (url.origin !== location.origin) return;
        if (decodeURIComponent(url.pathname).indexOf('”') !== -1 && decodeURIComponent(url.pathname).indexOf('/policies/shipping-policy') !== -1) {
          link.setAttribute('href', data.root.replace(/\/$/, '') + '/policies/shipping-policy');
          return;
        }
        if (/^\/(policies|pages|blogs|products|collections|cart|search)(\/|$)/.test(url.pathname)) {
          url.pathname = data.root.replace(/\/$/, '') + url.pathname;
          link.setAttribute('href', url.pathname + url.search + url.hash);
        }
      });
    }
    function metadata() {
      if (!isMirror) return;
      if (document.title !== data.title) document.title = data.title;
      ['meta[name="description"]', 'meta[property="og:description"]'].forEach(function (selector) {
        var el = document.querySelector(selector);
        if (el && el.content !== data.description) el.content = data.description;
      });
      var hero = data.images.find(function (item) { return item.source === 'mirror-hero-desktop.webp'; });
      if (hero) document.querySelectorAll('meta[property="og:image"],meta[property="og:image:secure_url"],meta[name="twitter:image"]').forEach(function (el) { if (el.content !== hero.url) el.content = hero.url; });
      var schema = document.getElementById('outletlet-product-schema');
      if (schema) {
        try {
          var value = JSON.parse(schema.textContent);
          if (value.name !== data.productTitle) {
            value.name = data.productTitle;
            value.description = data.description;
            if (hero) value.image = [hero.url].concat((value.image || []).slice(1));
            schema.textContent = JSON.stringify(value);
          }
        } catch (error) { }
      }
    }
    var queued = false;
    var observer;
    function apply() {
      queued = false;
      if (observer) observer.disconnect();
      if (isContact) {
        document.querySelectorAll('#MainContent h1,#MainContent h2').forEach(function (el) {
          if (/^(Contact Us|お問い合わせ Us)$/.test(normalize(el.textContent))) el.textContent = 'お問い合わせ';
        });
        document.querySelectorAll('#MainContent option').forEach(function (el) {
          if (textMap.has(normalize(el.textContent))) el.label = textMap.get(normalize(el.textContent));
        });
        document.querySelectorAll('#MainContent a').forEach(function (el) {
          if ((el.getAttribute('href') || '').indexOf('support@luxelull.com') !== -1) el.href = 'mailto:support@outletlet.com';
          if ((el.getAttribute('title') || '').indexOf('tel:+33') === 0) { el.href = 'tel:+17024838035'; el.title = '電話：+1 (702) 483-8035'; }
        });
      }
      translateText(document.body);
      replaceImages();
      localizeLinks();
      metadata();
      if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['src', 'srcset', 'alt', 'aria-label'] });
    }
    observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    });
    apply();
    window.addEventListener('load', apply, { once: true });
    setTimeout(apply, 1700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
